import * as React from 'react';

import { IFromDevelopersRoom } from '../../types/newbuilding';
import { Advertise, AdvertiseList, AgentsAdvertise } from '../../components/Advertise';
import { trackingActionClickAgentsFlats } from '../../actions/analytics';
import { TTypedThunkDispatch } from '../../types/thunk';
import { useDispatch } from 'react-redux';

interface IAdvertisesProps {
  fromDevelopersRooms: IFromDevelopersRoom[];
  fromAgentsCountsDisplay: string;
  fromAgentsPropsCount: number;
  fromAgentsPropsLink?: string;
  isFromAgentsAndOwnersFilter?: boolean;
  isPromoSnippet?: boolean;
  onOfferClick?(countDisplay: string): void;
}

export function Advertises({
  fromDevelopersRooms,
  fromAgentsPropsLink,
  fromAgentsPropsCount,
  fromAgentsCountsDisplay,
  isFromAgentsAndOwnersFilter,
  isPromoSnippet,
  onOfferClick,
}: IAdvertisesProps) {
  const dispatch = useDispatch<TTypedThunkDispatch>();

  const handleClickAgentsFlats = React.useCallback(() => dispatch(trackingActionClickAgentsFlats()), [dispatch]);

  if (fromDevelopersRooms && fromDevelopersRooms.length) {
    return (
      <AdvertiseList>
        {fromDevelopersRooms.map((room, index) => (
          <Advertise room={room} key={index} isPromoSnippet={isPromoSnippet} onOfferClick={onOfferClick} />
        ))}
      </AdvertiseList>
    );
  }

  if (!isFromAgentsAndOwnersFilter && fromAgentsPropsLink && fromAgentsPropsCount) {
    return (
      <AgentsAdvertise
        fromAgentsPropsLink={fromAgentsPropsLink}
        fromAgentsCountsDisplay={fromAgentsCountsDisplay}
        onClick={handleClickAgentsFlats}
      />
    );
  }

  return null;
}
